// extracted by mini-css-extract-plugin
export default {"wrapper":"customization_wrapper__qWvMx","content":"customization_content__Yt41C","opacity-transition":"customization_opacity-transition__h56Ih"};